import React from "react";
import ReactApexChart from "react-apexcharts";

interface RoleData {
    role: string;
    count: number;
}

interface Props {
    roleDistribution: RoleData[];
}

const RoleDistributionTreeMap: React.FC<Props> = ({ roleDistribution }) => {
    const fillColor = "#2A4971";
    const data = (roleDistribution || []).map((entry) => ({
        x: entry.role,
        y: entry.count,
        fillColor,
    }));

    const options = {
        chart: {
            type: "treemap" as const,
        },
        title: {
            align: "center" as const,
            margin: 10,
            offsetX: 0,
            offsetY: 0,
            floating: false,
            style: {
                fontSize: "18px",
                color: "#263238",
            },
        },
        legend: {
            show: true,
            position: "bottom" as const,
        },
    };

    return (
        <div>
            <ReactApexChart
                options={options}
                series={[{ data }]}
                type="treemap"
                height={350}
            />
        </div>
    );
};

export default RoleDistributionTreeMap;
